import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { branchQueryKeys } from '#/services/queryKeys';
import { Site } from '@jucy/rentals-api-client';
import { useRootStore } from './useRootStore';

export const useGetBranchByCode = (branchCode?: string): UseQueryResult<Site | undefined, Response> => {
    const store = useRootStore();
    return useQuery<Site | undefined, Response>({
        queryKey: branchQueryKeys.site(branchCode),
        queryFn: () => store.rentalBranchStore.getBranchByCode(branchCode || ''),
        refetchOnWindowFocus: false,
        retry: 0,
        enabled: Boolean(branchCode),
    });
};
